<style>
  .all {
    /* TODO: MODAA KUN https://github.com/angular/material2/issues/8493 on korjattu */
    max-height: 95vh;
  }
</style>

<div class="all" [class.iso]="!cellphone()" mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <div class="teksti">
    <div class="light-blue-text otsikko" [innerHtml]="'lemonaid-sopimus-dialog.asiakkaan-tunnistaminen' | translate | async"></div>
    <div class="dynamic-spacer"></div>
    <div class="dynamic-spacer"></div>
    @if (tunnistautuminenStepState() === 'start' || tunnistautuminenStepState() === 'error' || tunnistautuminenStepState() === 'error-cancel') {
      <div [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-tunnistamaan' | translate | async"></div>
      <div class="dynamic-spacer"></div>
      @if (tunnistautuminenStepState() === 'start') {
        <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistaudu-pankkitunnuksilla' | translate | async"></div>
      }
      @if (tunnistautuminenStepState() === 'error' || tunnistautuminenStepState() === 'error-cancel') {
        <div class="lemon-error" [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-epaonnistui' | translate | async"></div>
      }
      <div class="dynamic-spacer"></div>
      @if (commonError()) {
        <div class="lemon-error">{{ commonError() }}</div>
      }
      <div class="dynamic-spacer"></div>
      <div tunnistautuminen-nets-pankit [actionAfterSuccess]="'continue-standalone-dialog'" [kieli]="kieli()"></div>
      <div class="dynamic-spacer"></div>
      <div class="dynamic-spacer"></div>
    }
    @if (tunnistautuminenStepState() === 'success') {
      @if (!tunnistautujanTiedotAnnettu()) {
        <div [innerHtml]="'lemonaid-sopimus-dialog.anna-lisatiedot' | translate | async"></div>
        <form class="tunnistautuja">
          <mat-form-field class="tunnistautuja-short">
            <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
            <input type="text" [formField]="lomake.nimi" autocomplete="nothing" matInput data-lpignore="true" />
          </mat-form-field>
          <mat-form-field class="tunnistautuja-short">
            <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.kansallisuus">
              @for (kansa of kansallisuudetObservable | async; track kansa) {
                <mat-option [value]="kansa.koodi">
                  {{ kansa.nimi }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              @if (lomake.kansallisuus().touched()) {
                @if (onkoVirhe(lomake.kansallisuus, 'required')) {
                  {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                }
              }
            </mat-error>
          </mat-form-field>
          <mat-form-field class="tunnistautuja-long">
            <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
            <mat-select [formField]="lomake.pep">
              <mat-option [value]="true">
                {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
              </mat-option>
              <mat-option [value]="false">
                {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
              </mat-option>
            </mat-select>
            <mat-error>
              @if (lomake.pep().touched()) {
                @if (onkoVirhe(lomake.pep, 'required')) {
                  {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                }
              }
            </mat-error>
          </mat-form-field>
        </form>
        <div class="form-comment-container">
          <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
        </div>
        <div class="dynamic-spacer"></div>
        <div class="dynamic-spacer"></div>
        <div class="pep-miksi-kerataan-container">
          <div style="font-weight: bold">{{ 'lemonaid-sopimus-dialog.kyc.pep-miksi-kerataan' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div>{{ 'lemonaid-sopimus-dialog.kyc.pep-naita-tuntemistietoja' | translate | async }}</div>
        </div>
        <div class="dynamic-spacer"></div>
        <div class="dynamic-spacer"></div>
        @if (commonError()) {
          <div class="lemon-error">{{ commonError() }}</div>
        }
        <div class="button-container">
          <button (click)="tallennaTunnistautujaLisatiedot()" class="primarybutton" mat-button>{{ 'yleiset.jatka' | translate | async }}</button>
        </div>
        <div class="dynamic-spacer"></div>
      }
      @if (tunnistautujanTiedotAnnettu()) {
        <div class="dynamic-spacer"></div>
        <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-onnistui' | translate | async"></div>
        <div class="dynamic-spacer"></div>
        <div class="button-container">
          <button class="primarybutton" mat-button matDialogClose>{{ 'yleiset.jatka' | translate | async }}</button>
        </div>
        <div class="dynamic-spacer"></div>
      }
    }
  </div>
</div>
